import { LitElement, html, css } from 'lit'

class HHButtonWrapper extends LitElement {
  static properties = {}

  constructor() {
    super()
  }

  render() {
    return html`<slot></slot>`
  }

  static styles = css`
    :host([width='full']) {
      width: 100%;
    }

    :host([action='add']) ::slotted(button) {
      height: 5.8rem;
    }

    ::slotted(button),
    ::slotted(a) {
      min-width: var(--hh-min-width, 16rem);
      display: inline-flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      background-color: var(--hh-background, #012e36);
      color: var(--hh-color, #f6f4f0);
      transition: background var(--hh-duration-default, 300ms), color var(--hh-duration-default, 300ms), border var(--hh-duration-default, 300ms);
      border: 0.1rem solid var(--hh-background, #012e36);
      appearance: none;
      font: var(--hh-font);
      text-transform: var(--hh-text-transform, uppercase);
      letter-spacing: var(--hh-letter-spacing, 0.48px);
      text-decoration: none;
      height: 5rem;
      box-sizing: border-box !important;
      gap: var(--hh-gap, 1rem);
    }

    @media screen and (min-width: 1920px) {
      ::slotted(button),
      ::slotted(a) {
        height: max(calc(50 / var(--screen-size) * 100vw), 5rem);
      }
    }

    :host([width='full']) ::slotted(button),
    :host([width='full']) ::slotted(a) {
      width: 100%;
      max-width: none;
      box-sizing: border-box !important;
    }

    ::slotted(button:hover),
    ::slotted(a:hover) {
      background-color: var(--hh-color, #f6f4f0);
      color: var(--hh-text-color, #000);
    }

    :slotted(button:focus-visible),
    :slotted(a:focus-visible) {
      outline: 0.2rem solid var(--hh-color-focus, #0038ff);
      outline-offset: 0 !important;
    }

    ::slotted(button[disabled]) {
      background-color: var(--hh-disabled-bg-color, #dddad4);
      border-color: var(--hh-disabled-bg-color, #dddad4);
      color: var(--hh-color, #f6f4f0);
      cursor: not-allowed;
    }

    :host([theme='secondary']) ::slotted(button),
    :host([theme='secondary']) ::slotted(a) {
      background: var(--hh-background, transparent);
      border: var(--hh-border-width, 0.1rem) solid var(--hh-border-color, #000);
      color: var(--hh-secondary-color, #666666);
    }

    :host([theme='secondary']) ::slotted(button:hover),
    :host([theme='secondary']) ::slotted(a:hover) {
      background: var(--hh-text-color, #000);
      border-color: var(--hh-text-color, #000);
      color: var(--hh-color, #f6f4f0);
    }

    :host([theme='secondary']) ::slotted(button:disabled) {
      background: var(--hh-color, #f6f4f0);
      border-color: var(--hh-disabled-bg-color, #dddad4);
      color: var(--hh-disabled-bg-color, #dddad4);
    }

    :host([theme='secondary']) ::slotted(button:focus-visible),
    :host([theme='secondary']) ::slotted(a:focus-visible) {
      background: var(--hh-color, #f6f4f0);
      color: var(--hh-text-color, #000);
    }

    :host([theme='tertiary']) ::slotted(button),
    :host([theme='tertiary']) ::slotted(a) {
      position: relative;
      background: var(--hh-background, transparent);
      color: var(--hh-text-color, #000);
      padding: var(--hh-padding, 0) var(--hh-padding, 0) var(--hh-border-bottom-offset, 0);
      border: 0;
      min-width: unset;
      height: auto;
    }

    :host([theme='tertiary']) ::slotted(button):after,
    :host([theme='tertiary']) ::slotted(a):after {
      content: '';
      position: absolute;
      left: 0;
      bottom: 0;
      background-color: var(--hh-text-color, #000);
      width: calc(100% - var(--hh-letter-spacing, 0));
      height: var(--hh-underline-width, 0.1rem);
      pointer-events: none;
    }

    :host([theme='tertiary']) ::slotted(button:hover):after,
    :host([theme='tertiary']) ::slotted(a:hover):after {
      height: calc(var(--hh-underline-width, 0.1rem) * 2);
      background-color: var(--hh-background, #012e36);
    }

    :host([theme='tertiary']) ::slotted(button:disabled) {
      color: var(--hh-disabled-bg-color, #dddad4);
    }

    :host([theme='tertiary']) ::slotted(button:disabled):after {
      background-color: var(--hh-disabled-bg-color, #dddad4);
      height: var(--hh-underline-width, 0.1rem);
    }

    :host([theme='tertiary']) ::slotted(button:focus-visible),
    :host([theme='tertiary']) ::slotted(a:focus-visible) {
      border: 0;
      outline: none !important;
    }

    :host([theme='tertiary']) ::slotted(button:focus-visible):after,
    :host([theme='tertiary']) ::slotted(a:focus-visible):after {
      height: calc(var(--hh-underline-width, 0.1rem) * 2);
      background-color: var(--hh-color-focus, #0038ff);
    }

    :slotted() {
      font: var(--hh-font);
      text-transform: var(--hh-text-transform, uppercase);
      letter-spacing: var(--hh-letter-spacing, 0.48px);
    }

    :host([decoration~='rounded']) ::slotted(button),
    :host([decoration~='rounded']) ::slotted(a) {
      border-radius: var(--hh-border-radius, 0.4rem);
    }
  `
}

customElements.define('hh-button-wrapper', HHButtonWrapper)
